export const footprintUnit = {
  carbon: "kgCO2e",
  ecological: "gha",
  waste: "kg",
  water: "L"
}
